import { render } from "./navigation.vue?vue&type=template&id=63fe6bcf&ts=true"
import script from "./navigation.ts?vue&type=script&lang=ts&external"
export * from "./navigation.ts?vue&type=script&lang=ts&external"

import "./navigation.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__